// Test IDs for the wallet / credits feature (balance chip, top-up packs, success).
// Naming follows the directive in ./auth.js (keys camelCase, values kebab-case
// `<feature>-<element>`).

export const WALLET = {
	balanceChip: 'wallet-balance-chip',
	balanceSpendable: 'wallet-balance-spendable',
	balanceCash: 'wallet-balance-cash',
	balancePromo: 'wallet-balance-promo',
	topupPack: 'wallet-topup-pack', // suffix with -<packId> per button
	successStatus: 'wallet-success-status',
};
